export class BiondMealEvents {

    constructor(orderId, lineId, biondInterface, biondGlobalEvents, biondMealGlobalInterface) {
        // Renamed to be consistent with usage in methods like updateSaveButton
        this.biondInterface = biondInterface;
        this.orderId = orderId;
        this.lineId = lineId;
        this.container = document.querySelector('.meal-selection-section');
        this.biondGlobalEvents = biondGlobalEvents;
        this.biondMealGlobalInterface = biondMealGlobalInterface;
    }

    init() {
        if (!this.container) {
            console.warn('❌ Kein Container für Events gefunden.');
            return;
        }
        
        this.initBoxSelectEvent();
        this.applyPreSelectedMeals();
    }

    initBoxSelectEvent() {
        const container = this.biondInterface?.container;
        if (!container) {
            console.warn('❌ Container nicht gefunden.');
            return;
        }

        const radioButtons = container.querySelectorAll('input[name="box_choose"]');
        if (radioButtons.length === 0) {
            console.warn('❌ Keine Radio-Buttons mit name="box_choose" gefunden.');
            return;
        }

        const categoryValue = container.querySelector('.selected-meal-abo .category-value');

        radioButtons.forEach(radio => {
            radio.addEventListener('change', async (e) => {
                if (e.target.checked) {
                    const selectedBoxId = e.target.value;

                    // Titel aus dem zugehörigen Label holen
                    const labelText = container.querySelector(`label[for="${radio.id}"] .filter`);
                    if (labelText && categoryValue) {
                        categoryValue.textContent = labelText.textContent;
                    }
                    container.querySelector('.selected-meal-abo').classList.remove('active');
                    await this.biondInterface.switchBox(selectedBoxId);

                    this.lineId = this.biondInterface.lineId;
                    this.biondMealGlobalInterface.selectedMeals = [];
                    
                    this.biondMealGlobalInterface.updateMealCounter();
                    this.biondMealGlobalInterface.updateSaveButton();
                    this.biondMealGlobalInterface.renderSelectedMeals();
                    this.applyPreSelectedMeals()
                }
            });
        });
    }

    


    /*applyPreSelectedMeals() {
        if (!Array.isArray(this.biondMealGlobalInterface.selectedMeals this.box?.selectedMeals)) return;

        this.biondMealGlobalInterface.selectedMeals.forEach((meal) => {
            const mealVariantId = parseInt(meal.variantId.replace('gid://shopify/ProductVariant/',''));
            console.log(mealVariantId)
            if (mealVariantId && meal.quantity) {
                this.biondMealGlobalInterface.addMeal(mealVariantId, meal.quantity); 
                //this.addMeal(meal.variantId, meal.quantity);
            }
        });
    }*/

    applyPreSelectedMeals() {
        if (!Array.isArray(this.biondInterface.box?.selectedMeals)) return;

        this.biondInterface.box?.selectedMeals.forEach((meal) => {
            const mealVariantId = parseInt(meal.variantId.replace('gid://shopify/ProductVariant/',''));
            console.log(mealVariantId)
            if (mealVariantId && meal.quantity) {
                this.biondMealGlobalInterface.addMeal(mealVariantId, meal.quantity); 
                //this.addMeal(meal.variantId, meal.quantity);
            }
        });
    }


   
}